import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'conviteStatus'
})
export class ConviteStatusPipe implements PipeTransform {

  transform(value: any): any {
    if (value) {
      return 'Usado';
    }
    return 'Não Usado';
  }

}
